import { ConfirmDialog } from '../../components';

import type { NoMedicationConfirmDialogProps } from './types';

export default function NoMedicationConfirmDialog({
  open,
  hasSavedMedications,
  confirmLoading,
  onClose,
  onConfirm,
}: NoMedicationConfirmDialogProps) {
  return (
    <ConfirmDialog
      open={open}
      title={hasSavedMedications ? 'Remove all medications?' : 'Confirm no medication?'}
      message={
        hasSavedMedications ? (
          <>
            Selecting "No medication taken by the client" will permanently delete all medications
            you've entered.
            <br />
            This action can't be undone.
          </>
        ) : (
          'This marks that the client currently takes no medication.'
        )
      }
      confirmLabel={hasSavedMedications ? 'Remove all' : 'Confirm'}
      confirmLoading={confirmLoading}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
}
